import React, { PropsWithChildren } from "react";
import ReactDOM from "react-dom";

import { Container } from "./MapOverlay.styles";

interface MapOverlayProps extends PropsWithChildren {
  /**
   * Whether to show the semi-transparent background overlay.
   * @default true
   */
  showOverlay?: boolean;
  /**
   * Whether to center the content in the map.
   * @default true
   */
  centerContent?: boolean;
}

const MapOverlay: React.FC<MapOverlayProps> = ({ children, showOverlay = true, centerContent = true }: MapOverlayProps) => {
  const mapElement = document.getElementById("mapContainer");

  const render = () => (
    <Container $showOverlay={showOverlay} $centerContent={centerContent}>
      {children}
    </Container>
  );

  if (!mapElement) return render();

  /**
   * We use a portal to move the MapOverlay component within the Map
   * DOM Object. This allows the overlay to be used within any component
   * and DOM tree.
   */
  return ReactDOM.createPortal(render(), mapElement);
};

export default MapOverlay;
